import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { MsalProvider, useMsal } from "@azure/msal-react";

import { msalInstance } from "./auth/msal";
import { startSessionWatcher } from "./auth/sessionWatcher";
import { Layout } from "./components/Layout";
import { RequireAuth } from "./components/RequireAuth";
import { LoginPage } from "./pages/Login";
import { LogoutCallbackPage } from "./pages/LogoutCallback";
import { AuthCallbackPage } from "./pages/AuthCallback";
import { ConsentsPage } from "./pages/Consents";
import { NotFoundPage } from "./pages/NotFound";

function RoutesInner() {
  const { inProgress } = useMsal();

  useEffect(() => {
    const stop = startSessionWatcher(() => {
      // expired -- the watcher will fire login(); nothing to do here.
    });
    return stop;
  }, []);

  // While MSAL boots, don't render protected routes (they'd flash the
  // login screen for a frame before the cache loads).
  if (inProgress === "startup") {
    return <div className="centered"><div className="skeleton skeleton--line" style={{ width: 200 }} /></div>;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route path="/auth/logout" element={<LogoutCallbackPage />} />

      {/* This app IS the consent administration: the index route is the
          consent management page. No dashboard / other pages. */}
      <Route element={<RequireAuth><Layout /></RequireAuth>}>
        <Route index element={<ConsentsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
      <Route path="/404" element={<Navigate to="/notfound" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <RoutesInner />
    </MsalProvider>
  );
}
